import { render, staticRenderFns } from "./lender-sidebar-layout.vue?vue&type=template&id=1581ce94"
import script from "./lender-sidebar-layout.vue?vue&type=script&lang=ts"
export * from "./lender-sidebar-layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1581ce94')) {
      api.createRecord('1581ce94', component.options)
    } else {
      api.reload('1581ce94', component.options)
    }
    module.hot.accept("./lender-sidebar-layout.vue?vue&type=template&id=1581ce94", function () {
      api.rerender('1581ce94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/main/layouts/lender-sidebar-layout.vue"
export default component.exports